import "./styles.scss";

import { FaPlus } from "react-icons/fa";
import { TbRepeat } from "react-icons/tb";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { findItemByStatus } from "../ModalMyHistory/util/findItemByStatus";
import { setContentFilesExercisesSelected } from "../../../store/slices/contentExercises.slice";
import { regenerateContentExercises, duplicateContentExercises } from "../../../store/middleware";

function ModalMyHistoryActions({
  data,
  showModal,
  refetchData,
  setShowModal,
  onCloseModalMyHistory,
  handleOpenModalGenerateExercisesWithAI,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);

  const closeModal = () => setShowModal(false);

  const handleRedo = async (row) => {
    const doneItem = findItemByStatus(row, "done");
    const exerciseId = doneItem?.id ?? row.id;
    if (!exerciseId) return;

    const payload = { userId: user?.id, exerciseId };
    const response = await dispatch(duplicateContentExercises(payload));
    await dispatch(setContentFilesExercisesSelected(response));

    handleOpenModalGenerateExercisesWithAI();
    closeModal();
    onCloseModalMyHistory();
  };

  const handleGenerateNew = async (row) => {
    const doneItem = findItemByStatus(row, "done");
    const exerciseId = doneItem?.id ?? row.id;
    if (!exerciseId) return;

    const payload = { userId: user?.id, exerciseId };
    await dispatch(regenerateContentExercises(payload));
    await closeModal();
    await refetchData();
  };

  return (
    <Dialog open={showModal} onClose={closeModal} className="modalMyHistoryActions">
      <div className="containerMyHistoryActions">
        <h3 className="title">{t("OPTIONS")}</h3>

        <div className="content">
          <button type="button" className="actionBtn" onClick={() => handleRedo(data)}>
            <TbRepeat size={25} color="#004fff" />
            <span>{t("MY_HISTORY_REDO")}</span>
          </button>

          <button type="button" className="actionBtn" onClick={() => handleGenerateNew(data)}>
            <span className="plusCircle">
              <FaPlus size={15} color="#ffffff" />
            </span>
            <span className="generateText">{t("MY_HISTORY_GENERATE_NEW")}</span>
          </button>
        </div>

        <div className="footer">
          <button className="buttonBack" onClick={closeModal}>
            {t("BACK")}
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default ModalMyHistoryActions;
